import { FunctionComponent, useEffect, useState } from 'react';
import styles from './Feedings.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { Feeding } from 'model/NewMultipleBooking';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { FeedingComponent } from './FeedingComponent';

interface Props {
    feeding: Feeding;
    index: number;
    disabled?: Array<number>;
    optional?: boolean;
    isActive?: boolean;
    onUpdate: (index: number, feeding: Feeding) => void;
    onDelete: (index: number) => void;
    onActivate: (isActive: boolean) => void;
}

export const Feedings: FunctionComponent<Props> = ({
    feeding,
    index,
    disabled,
    optional,
    isActive,
    onUpdate,
    onDelete,
    onActivate
}) => {
    const [feedingState, setFeedingState] = useState<Feeding>(feeding);

    useEffect(() => {
        onUpdate(index, feedingState);
    }, [feedingState]);

    return (
        <>
            <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>
                    <h4 className={styles.toggleSwitch}>
                        Feeding {!optional || (optional && isActive) ? index + 1 : ''}
                    </h4>
                    {index === 0 && optional && (
                        <Switch
                            checked={isActive}
                            onChange={() => onActivate(!isActive)}
                        />
                    )}
                </div>
                {((!optional && index > 0) || (optional && isActive)) && (
                    <div className={styles.deleteButton}>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            onClick={() => onDelete(index)}
                        />
                    </div>
                )}
            </div>
            {(!optional || (optional && isActive)) && (
                <FeedingComponent
                    feedingState={feedingState}
                    disabled={disabled}
                    onFeedingChange={setFeedingState}
                />
            )}
        </>
    );
};

export default Feedings;
